import { BuildingOfficeIcon, HomeIcon, VideoCameraIcon } from '@heroicons/react/24/outline';
import { DeliveryModeTypes } from '@/costants/enum';
import { capitalizeWordsInString } from '@/utils/string';
import { ELBadge } from '@davincihealthcare/elty-design-system-react';

type DeliveryModesProps = {
  deliveryModesList: DeliveryModeTypes[];
  city?: string;
};

const DeliveryMode = ({
  LeadingIcon,
  label,
}: {
  LeadingIcon: React.ForwardRefExoticComponent<
    Omit<React.SVGProps<SVGSVGElement>, 'ref'> & {
      title?: string | undefined;
      titleId?: string | undefined;
    } & React.RefAttributes<SVGSVGElement>
  >;
  label: string;
}) => (
  <div className="inline-flex items-center gap-x-4">
    <ELBadge Icon={LeadingIcon} color="secondary" size="small" applyNativeSVGSize />
    <div className="flex flex-col">
      <h4 className="text-base font-semibold text-neutral-darker">{label}</h4>
    </div>
  </div>
);

const DeliveryModes = ({ deliveryModesList, city }: DeliveryModesProps) => (
  <div className="grid grid-cols-1 gap-y-4 self-start" data-cy="profile delivery modes">
    <h3 className="text-xs font-semibold text-neutral-lighter lg:mb-3 lg:text-base lg:font-medium xl:mb-0.5">Modalità di erogazione</h3>
    {deliveryModesList.map(item => {
      switch (item) {
        case DeliveryModeTypes.Onsite: {
          const label = `In sede a ${capitalizeWordsInString(city)}`;
          return <DeliveryMode key={label} LeadingIcon={BuildingOfficeIcon} label={label} />;
        }
        case DeliveryModeTypes.Online: {
          const label = `Online`;
          return <DeliveryMode key={label} LeadingIcon={VideoCameraIcon} label={label} />;
        }
        case DeliveryModeTypes.Domiciliary: {
          const label = `A domicilio a ${capitalizeWordsInString(city)}`;
          return <DeliveryMode key={label} LeadingIcon={HomeIcon} label={label} />;
        }
      }
    })}
  </div>
);

export default DeliveryModes;
